
import { motion } from "framer-motion";
import { FreelancerCard, FreelancerProps } from "./FreelancerCard";
import { GridLayoutType } from "./FreelancerGrid";

interface GridContainerProps {
  gridLayout: GridLayoutType;
  freelancers: (FreelancerProps & { matchScore?: number })[];
  showMatchScore?: boolean;
  handleFreelancerDetail?:any
}

export const GridContainer = ({ 
  gridLayout, 
  freelancers, 
  showMatchScore = false,
  handleFreelancerDetail
}: GridContainerProps) => {
  
  const getGridClass = () => {
    switch (gridLayout) {
      case 'compact':
        return 'grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6';
      case 'spacious':
        return 'grid-cols-1 md:grid-cols-2 gap-8';
      case 'comfortable':
      default:
        return 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6';
    }
  };

  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  return (
    <motion.div 
      // className={`grid ${getGridClass()}`}
      className={`grid`}
      variants={container}
      initial="hidden"
      animate="show"
    >
      {freelancers.map((freelancer,idx) => (
        <motion.div
          key={idx}
          variants={{
            hidden: { opacity: 0, y: 20 },
            show: { opacity: 1, y: 0 }
          }}
          transition={{ duration: 0.3 }}
          className="h-full" // Ensure the motion div takes full height
        >
          <FreelancerCard 
            handleFreelancerDetail={() =>handleFreelancerDetail(freelancer)}
            {...freelancer} 
            name={freelancer?.fullName}
            showMatchScore={showMatchScore}
          />
        </motion.div>
      ))}
    </motion.div>
  );
};
